import JobsGateway from './JobsGateway'
import { responsiveMap } from 'antd/lib/_util/responsiveObserve'

export default class JobsService {
  constructor (jobsGateway) {
    this.JobsGateway = jobsGateway || new JobsGateway()

    this.getJobTypes = this.getJobTypes.bind(this)
    this.getJobs = this.getJobs.bind(this)
    this.getJob = this.getJob.bind(this)
    this.addJob = this.addJob.bind(this)
    this.updateJob = this.updateJob.bind(this)
    this.deleteJob = this.deleteJob.bind(this)
  }

  getJobTypes (params) {
    return this.JobsGateway
      .getJobTypes(params)
      .then(response => {
        const { jobTypes } = response
        return jobTypes.map(item => ({
          key: item.type,
          title: item.type
        }))
      })
  }

  getJobs () {
    return this.JobsGateway
      .getJobs()
      .then(response => response.map((item, index) => ({ id: '' + index, key: item, name: item })))
  }

  getJob (params) {
    return this.JobsGateway
      .getJob(params)
      .then(response => response)
  }

  addJob (params) {
    return this.JobsGateway
      .addJob(params)
      .then(response => response)
  }

  updateJob (query) {
    return this.JobsGateway
      .updateJob(query)
      .then(response => response)
  }

  deleteJob (params) {
    return this.JobsGateway
      .deleteJob(params)
      .then(response => response)
  }
}



// WEBPACK FOOTER //
// ./src/api/jobs/JobsService.js